{
	"_comment": "This file is updated by the build process. Do not edit it manually.",
	"version": "1.82.0",
	"hash": "36e13d29ee8a7372752988bdc69deb4c368bdbcc"
}
